
  var rt = require("@stylable/runtime/cjs/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Captcha3940957316",
      {"classes":{"root":"Captcha3940957316__root","captcha":"Captcha3940957316__captcha","checkbox":"Captcha3940957316__checkbox"},"vars":{},"stVars":{},"keyframes":{}},
      "",
      -1,
      module.id
  );
  